<template>
  <div class="wrap">
    <Row class="header">
      <Col span="8">
      <div class="logo-box"></div>
      <!--                <img class="logo" src="@/assets/images/logo.png">-->
      </Col>
      <Col
        class="menu"
        span="16"
      >
      <!--                <router-link class="router-item" to="index">工作台</router-link>-->
      <!--                <router-link class="router-item" to="">控制台</router-link>-->
      <!--                <router-link class="router-item" to="/developerCenter/index">开发者中心</router-link>-->
      </Col>
    </Row>
    <Row class="content">
      <Col span="12">
      <div class="login-bg-box">
        <img
          class="login-bg"
          src="@/assets/images/login-bg.png"
        >
      </div>
      </Col>
      <Col
        span="12"
        class="form"
      >
      <div class="form-top">
        <span class="form-top-name">注册</span>
        <span class="form-top-text">已有账号？</span>
        <span
          class="form-top-login"
          @click="$router.push('/login')"
        >立即登录</span>
      </div>
      <Form
        ref="form"
        :model="params"
      >
        <FormItem
          v-for="(item,index) in formItems"
          :key="index"
          :prop="item.prop"
          :rules="item.rules||[]"
        >
          <Row
            v-if="item.prop == 'smsCode'"
            class="verify-code-box"
          >
            <Col span="2"> <i
              class="iconfont icon-iconfont-5"
              style="font-size: 26px; padding-left: 8px;"
            ></i></Col>
            <Col span="14">
            <Input
              v-model="params[item.prop]"
              v-bind="item"
              clearable
              v-on="item.on"
            >
            </Input>
            </Col>
            <Col
              span="8"
              style="text-align: right;"
            >
            <Button
              v-if="time<=0"
              type="text"
              :disabled="!params.slider|| !params.phone"
              @click="sendCode"
            >
              发送验证码
            </Button>
            <MyCountDown
              v-if="time>0"
              :time="time"
              format="ss 秒"
              @finish="time=0"
            />
            </Col>
          </Row>
          <MyFormItemField
            v-else
            v-model="params[item.prop]"
            :class="item.class"
            :type="item.type"
            v-bind="item"
            v-on="item.on"
          >
          </MyFormItemField>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            long
            class="login-btn"
            @click="handleSubmit('form')"
          >
            注册
          </Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <div class="footer">
      <p>地址：中国浙江杭州西湖区文三路支付90号东部软件园6号楼6层</p>
      <p>浙江深大智能科技有限公司 版权所有 2008-2020</p>
    </div>
  </div>
</template>
<script>
import MyCountDown from '@/components/CountDown/index';
import md5 from 'js-md5';

export default {
  components: { MyCountDown },
  data() {
    return {
      time: 0,
      loginType: 1,
      formItems: [
        {
          prop: 'phone',
          type: 'text',
          placeholder: '请输入手机号',
          prependIcon: 'ios-phone-portrait',
          class: 'form-input',
          rules: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { required: true, validator: this.common.validate.phone, trigger: 'blur' },
          ],
        },
        {
          prop: 'slider',
          type: 'slider',
          // rules: [
          //     {
          // required: true,
          // validator: (rule, value, callback) => {
          //     if (value !== true) {
          //         callback(new Error('拖动滑块到最右边'))
          //         return
          //     } else {
          //         callback()
          //     }
          // },
          // trigger: "change"
          // }
          // ],
        },
        {
          prop: 'smsCode',
          type: 'text',
          placeholder: '请输入验证码',
          rules: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
        {
          prop: 'accPwd',
          type: 'password',
          prependIcon: 'ios-lock-outline',
          placeholder: '请输入密码',
          class: 'form-input',
          rules: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 12, message: '密码仅支持6-12位', trigger: 'blur' },
          ],
        },
        {
          prop: 'accPwdConfirm',
          type: 'password',
          prependIcon: 'ios-lock-outline',
          placeholder: '请再次输入密码',
          class: 'form-input',
          rules: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { required: true, validator: this.accPassConfirm, trigger: 'blur' },
          ],
        },
      ],
      params: {
        // user: '',
        // password: '',
        appId: 'payCenterAdmin',
        phone: '',
        accPwd: '',
        slider: false,
        smsCode: '',
        key: '',
      },
    };
  },

  created() {

  },
  methods: {
    // 登录
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const url = '/api/user/register';
          const { accPwd, appId, phone, smsCode, key } = this.params;
          if (!key) {
            this.$Message.error('短信验证码不正确');
            return;
          }
          const params = { accPwd: md5(accPwd.trim()), appId, phone, smsCode, key };
          this.$http.post(url, this.common.utils.trim(params)).then(res => {
            if (res.success) {
              this.$store.commit('setUserInfo',res.data);
              this.$Message.success('注册成功');
              this.$router.push('/supplyInfo');
            } else {
              this.$Message.error(res.message || '请求出错');
            }
          });
        }
      });
    },
    // 发送短信
    sendCode() {
      const url = '/api/user/register/sendSms';
      const { phone } = this.params;
      const params = {
        // appId,
        phone: phone.replace(/(^\s*)|(\s*$)/g, ''),
      };
      this.$http.post(url, params).then(res => {
        if (res.success) {
          this.time = 60000;
          this.params.key = res.data;
          this.$Message.success('短信发送成功');
        } else {
          this.params.slider = false;
          this.$Message.error(res.message || '短信发送失败');
        }
      });
    },
    accPassConfirm(rule, value, callback) {
      if (!rule.required && !value) {
        // 非必填时
        callback();
        return;
      }
      const accPass = this.params.accPwd;

      if (value.trim() !== accPass.trim()) {
        callback(new Error('两次密码输入不一致！'));
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped lang="less">
    .wrap {

    }
    .header {
      padding: 20px 40px 5px;
      border-bottom: 1px solid #e5e5e5;
      .logo-box {
        height: 50px;
      }
      .logo {
        width: 160px;
      }
      .menu {
        text-align: right;
        line-height: 40px;
        .router-item {
          color: #999;
          display: inline-block;
          margin: 0 20px;
        }
      }
    }
    .login-bg-box {
      text-align: right;
      padding-right: 40px;
      .login-bg {
        width: 530px;
      }
    }
    .content {
      padding-top: 120px;
    }
    .form {
      box-sizing: border-box;
      padding: 10px 20px;

      /* margin-top: 150px; */
      width: 450px;

      /* background-color: rgba(0,0,0,.5); */
      border-radius: 10px;
      box-shadow: 0 0 10px 1px #e7e7e7;
      .form-top {
        padding: 10px 0 20px;
        .form-top-name {
          color: #256af7;
          margin-right: 20px;
          font-size: 18px;
        }
        .form-top-text {
          color: #999;
          font-size: 13px;
          margin-right: 8px;
        }
        .form-top-login {
          color: #256af7;
          font-size: 13px;
        }
      }
      .form-input {
        border-bottom: 1px solid #ccc;
        padding-bottom: 5px;
        /deep/ .ivu-input-group-prepend {
          border: 0;
          background-color: transparent;
        }
        /deep/ .ivu-input {
          border: 0;
          background-color: transparent !important;
          &:focus {
            box-shadow: 0 0 0 0;
          }
        }
        /deep/ .ivu-input-group-prepend .ivu-icon {
          font-size: 28px;
        }
      }
      /deep/ .ivu-form-item:first-child .form-input {
        border-color: #256af7;
      }
      .login-btn {
        margin-top: 20px;
        font-size: 18px;
        height: 45px;
        background-color: #256af7;
        border-color: #256af7;
      }
      .verify-code-box {
        border-bottom: 1px solid #ccc;
        padding-bottom: 5px;
        /deep/ .ivu-input {
          border: 0;
          background-color: transparent !important;
          &:focus {
            box-shadow: 0 0 0 0;
          }
        }
      }
    }
    .footer {
      /* position: fixed; */

      /* bottom: 30px; */

      /* width: 100%; */
      margin: 100px 0 30px 0;
      text-align: center;
      color: #999;
      font-size: 13px;
      line-height: 2;
    }
</style>
